const QueryKeys = {
  igloo: {
    locksList: "iglooLocksList",
    lockEligibleAssets: "iglooLockEligibleAssets",
    lockPins: "iglooLockPins",
    getPinGenerationTime: "iglooGetPinGenerationTime",
    setPinGenerationTime: "iglooSetPinGenerationTime",
  },
  order: {
    orderParticipantsFields: "orderParticipantsFields", // List all the participants field details of an order
    orderParticipants: "orderParticipants", // Lists all the participants details of an order
    getAllNotes: "getAllNotes",
  },
  waiver: {
    signedWaivers: "signedWaivers",
    templatesList: "templatesList",
  },
  integrations: {
    getIntegrations: "getIntegrations",
    getSqaureupLocations: "getSqaureupLocations",
    getAllStripePosReaders: "getAllStripePosReaders",
  },
  swapResource: {
    assetsBasedOnBookingId: "assetsBasedOnBookingId",
    availableResourcesForSwap: "availableResourcesForSwap",
    swapResourceActionLogs: "swapResourceActionLogs",
    bookingDetails: "bookingDetails",
  },
  resources: {
    resourceActiveClosure: "resourceActiveClosure",
    resourcePastClosure: "resourcePastClosure",
  },
}

export default QueryKeys
